import { createElement, useMemo, useState } from "react";
import { toast } from "../../lib/notify";
import { http, formatApiError } from "../../lib/api";
import { APPR_MATCH } from "../../lib/entryPricing";

const backParam = () => encodeURIComponent(window.location.pathname + window.location.search);
const approverPath = (l, don) => `/tanimlar/projeler?proje=${l.project_id}&sube=${l.id}&don=${don}`;

// onay akışı: seçim, onaylı/onaysız filtresi, şube yetkilisi eksikleri, onaya gönderme
export function useApprovalFlow({ visEntries, entries, allLocs, setAllLocs, form, loadAll, navigate }) {
  const [apprSel, setApprSel] = useState([]);
  const [apprFilter, setApprFilter] = useState("all"); // all | approved | unapproved
  const [showBulkApprover, setShowBulkApprover] = useState(false);
  const visEntriesAppr = useMemo(() => visEntries.filter(APPR_MATCH[apprFilter] || APPR_MATCH.all), [visEntries, apprFilter]);

  // seçili (veya seçim yoksa görünen onaysız) kayıtların şubelerinde onaylayıcı kullanıcı tanımlı mı?
  const approverMissing = useMemo(() => {
    let src = apprSel.length ? entries.filter((e) => apprSel.includes(e.id)) : visEntriesAppr.filter((e) => !e.is_price_diff && e.approval_status !== "approved");
    if (!apprSel.length) {
      if (form.project_id) src = src.filter((e) => e.project_id === form.project_id);
      if (form.service_id) src = src.filter((e) => e.service_id === form.service_id);
      else if (form.category_id) src = src.filter((e) => e.category_id === form.category_id);
    }
    const seen = new Map();
    for (const e of src) {
      const l = allLocs.find((x) => x.id === e.location_id);
      if (l && !l.approver_user_id && !seen.has(l.id)) seen.set(l.id, { id: l.id, name: l.name, code: l.branch_code, project_id: l.project_id });
    }
    return [...seen.values()];
  }, [apprSel, entries, visEntriesAppr, allLocs, form.project_id, form.category_id, form.service_id]);

  const goApprover = (l) => navigate(approverPath(l, backParam()));
  const quickApprover = async (l, uid) => {
    if (!uid) return;
    try {
      await http.patch(`/locations/${l.id}/approver`, { approver_user_id: uid });
      toast.success(`${l.name}: onaylayıcı atandı`);
      setAllLocs((ls) => ls.map((x) => (x.id === l.id ? { ...x, approver_user_id: uid } : x)));
    } catch (e) { toast.error(formatApiError(e)); }
  };
  const sendApproval = async () => {
    if (!apprSel.length) return toast.error("Onaya gönderilecek kayıtları seçin");
    try {
      const { data } = await http.post("/entries/send-approval", { entry_ids: apprSel });
      toast.success(`${data.pending} kayıt onaya gönderildi · ${data.mails} şube yetkilisine mail`);
      if (data.skipped_flow) toast.info(`${data.skipped_flow} ekstra temizlik kaydı zaten onay zincirinde (girişte otomatik GM onayına düşer)`);
      if (data.no_approver?.length) {
        const don = backParam();
        data.no_approver.forEach((l) => toast.warning(createElement("span", { "data-testid": "toast-no-approver" }, "Şube yetkilisi tanımsız: ", createElement("button", { type: "button", "data-testid": `toast-link-approver-${l.id}`, className: "underline font-bold text-sky-700", onClick: () => navigate(approverPath(l, don)) }, `${l.name} — şube kartından onaylayıcı atayın`)), { duration: 12000 }));
      }
      setApprSel([]); loadAll(); window.dispatchEvent(new Event("approvals-changed"));
    } catch (e) { toast.error(formatApiError(e)); }
  };

  return { apprSel, setApprSel, apprFilter, setApprFilter, visEntriesAppr, approverMissing, goApprover, quickApprover, sendApproval, showBulkApprover, setShowBulkApprover };
}
